import newsNavigationRoutes from "./navigationRoutes";
import NewsPage from "../Pages/NewsPage";

// Public routes that don't require authentication
const publicRoutes: Array<{
  path: string;
  element: React.ComponentType;
  name: string;
}> = [
  {
    path: newsNavigationRoutes.NEWS_HOME,
    element: NewsPage,
    name: "News Home",
  },
];

// Main routes configuration
const routes = [
  {
    type: "public",
    routes: publicRoutes,
  },
];

export default routes;
